<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">
      Experiences
    </h4>

    <checkbox
      v-for="exp in availableExperiences"
      :key="exp.id"
      @change="$emit('filter-changed')"
      v-model="options.experienceOptions[`opt${exp.id}`]">
      {{ exp.name }}
    </checkbox>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  inject: ['options'],
  computed: {
    ...mapGetters(['availableExperiences'])
  }
}
</script>